import type { MessageEvent } from './reserved-keywords';

type Subscriber = (msg: MessageEvent) => void;

const subscribers = new Set<Subscriber>();

export const subscribeAppEvents = (fn: Subscriber) => {
  subscribers.add(fn);

  return () => {
    subscribers.delete(fn);
  };
};

export const dispatchAppEvent = (msg: MessageEvent) => {
  subscribers.forEach((fn) => fn(msg));
};
